import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
import { Link, NavLink } from 'react-router-dom';
import { BareButtonStyle, Button } from '../../../core/components/styled';
import { Icon } from '../../../core/components';
import { fadeAndSlideInUp } from '../../../core/styles';

export const BellNotification = styled.div`
  position: relative;
  vertical-align: middle;
  margin: -5px 15px 0 10px;
  width: 23px;
  height: 30px;
  color: #ffffff;
  display: inline-block;
  font-size: 12px;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center center;
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='24px' height='24px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3Ebell%3C/title%3E%3Cg id='Symbolicons-Pro---Solid' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Time' transform='translate(-72.000000, -216.000000)' fill='%23ffffff' fill-rule='nonzero'%3E%3Cpath d='M91.00011,228.00005 L91.00011,223.00005 C91.00011,219.134057 87.8661032,216.00005 84.00011,216.00005 C80.1341168,216.00005 77.00011,219.134057 77.00011,223.00005 L77.00011,228.00005 L72.00011,235.00005 L96.00011,235.00005 L91.00011,228.00005 Z M84.00011,240.00005 C85.818954,239.994545 87.4046295,238.761487 87.85802,237.00005 L80.14219,237.00005 C80.5955814,238.761491 82.1812623,239.99455 84.00011,240.00005 Z' id='bell'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  &:focus {
    outline: none !important;
  }
`;

export const NavigationMenuItem = styled(Link)`
  display: block;
  padding: 8px 20px;
  text-transform: none;
  background-color: #fff;
  color: ${props => props.theme.brandDefault};

  &:hover {
    background-color: ${props => props.theme.brandPrimary};
    color: #fff;
  }
`;
export const NavigationMenuItemButton = styled(Button)`
  width: 100%;
  border-radius: 0;
  font-size: 15px;
  font-weight: 500;
  display: block;
  padding: 8px 20px;
  text-transform: none;
  background-color: #fff;
  color: ${props => props.theme.brandDefault};

  &:hover {
    background-color: ${props => props.theme.brandPrimary};
    color: #fff;
  }
`;

export const NavigationMenu = styled.div<{ isOpen: boolean; isNotifications?: boolean }>`
  position: absolute;
  display: none;
  top: ${props => (props.isNotifications ? '35px' : '60px')};
  left: ${props => (props.isNotifications ? '-147px' : '-90px')};
  width: ${props => (props.isNotifications ? '245px' : '240px')};
  background-color: #fff;
  border: 1px solid ${transparentize(0.96, '#000')};
  box-shadow: 0 2px 4px ${transparentize(0.9, '#000')};

  @media (max-width: ${props => props.theme.desktopLargeBreakpoint}) {
    left: auto;
    right: 0;
  }

  ${props =>
    props.isOpen &&
    css`
      display: block;
      animation: ${fadeAndSlideInUp} 0.1s ease-out;
    `};
`;

export const SubNavigationItemWrapper = styled.div<{ isActionRequired?: boolean; active?: boolean }>`
  ${props =>
    !props.isActionRequired &&
    css`
      margin-right: 60px;
    `};

  ${props =>
    props.active &&
    css`
      ${SubNavigationItem} {
        color: ${props => props.theme.brandPrimary};
      }
    `};

  &:last-child {
    margin-right: 0;
  }
`;

export const SubNavigationItem = styled(NavLink)<{ active?: boolean }>`
  display: flex;
  align-items: center;
  height: 100%;
  text-transform: capitalize;
  margin-right: 60px;
  font-size: 16px;

  &:last-child {
    margin-right: 0;
  }

  &.active {
    color: ${props => props.theme.brandPrimary};
  }
`;

export const SubNavigationBar = styled.div`
  display: flex;
  justify-content: center;
  height: 70px;
  background-color: #fff;
`;

export const BaseNavigationItemCount = styled.div<{ isVisible: boolean }>`
  border-radius: 50%;
  width: 20px;
  height: 20px;
  padding: 4px 2px;
  background: red;
  color: #fff;
  text-align: center;
  font: 10px Arial, sans-serif;
  margin: 0px 10px;
  display: none;
  ${props =>
    props.isVisible &&
    css`
      display: block;
      }
    `};
`;

export const MainNavigationItemCount = styled(BaseNavigationItemCount)`
  border: 1px solid #666;
  &:hover {
    cursor: pointer;
  }
`;

export const MainNavigationLogo = styled(Link)`
  display: block;
  width: 176px;
  height: 30px;
  background: url('data:image/svg+xml;base64,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');
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;

  ${MainNavigationItemCount} {
    position: absolute;
    right: -40px;
    top: 2px;
  }
`;

export const MainNavigationLogoHome = styled.a`
  width: 176px;
  height: 30px;
  background: url('data:image/svg+xml;base64,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');
  background-size: cover;
`;

export const MainNavigationIcon = styled(Icon)`
  width: 27px;
  height: 27px;
`;

export const MainNavigationButton = styled.div<{ isHighlighted: boolean }>`
  ${BareButtonStyle};
  position: relative;
  display: flex;
  align-items: center;
  justify-self: flex-end;
  height: 100%;
  border-bottom: 4px solid transparent;
  text-transform: uppercase;
  font-weight: ${props => props.theme.fontWeightMedium};
  font-size: 15px;
  position: absolute;
  right: 0;
  top: 0;

  ${props =>
    props.isHighlighted &&
    css`
      ${MainNavigationIcon} {
        color: ${props => props.theme.brandPrimary};
      }
    `};
`;

export const MainNavigationItem = styled(NavLink)`
  position: relative;
  display: flex;
  align-items: center;
  justify-self: flex-end;
  height: 100%;
  margin-left: 25px;
  border-bottom: 4px solid transparent;
  text-transform: uppercase;
  font-weight: ${props => props.theme.fontWeightMedium};
  font-size: 15px;

  @media (max-width: ${props => props.theme.tabletBreakpoint}) {
    margin-left: 20px;
  }

  ${MainNavigationIcon} {
    margin-right: 10px;
  }

  &.active {
    border-bottom-color: ${props => props.theme.brandPrimary};

    ${MainNavigationIcon} {
      color: ${props => props.theme.brandPrimary};
    }
  }
`;

export const SubNavigationItemCount = styled(BaseNavigationItemCount)`
  border: 1px solid #dcdcdc;
`;

export const MainNavigationBarContent = styled.div`
  display: flex;
  align-items: center;
  width: 1140px;
  height: 70px;
  position: relative;

  @media (max-width: ${props => props.theme.desktopBreakpoint}) {
    width: 100%;
    padding: 0 15px;
  }
`;

export const MobileNavigationNodesList = styled.ul`
  list-style: none;
  margin: 10px 10px;
  height: calc(100% - 20px);
  display: flex;
  flex-direction: column;
`;

export const MobileNavigationNode = styled.li`
  margin-bottom: 25px;
`;

export const MobileNavigationNodeTitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const MobileNavigationSubNodesList = styled.ul<{ isAccount?: boolean }>`
  list-style: none;
  margin: 0 38px;
  ${p =>
    p.isAccount &&
    css`
      padding-bottom: 120px;
    `}
`;

export const MobileNavigationSubNode = styled.li`
  list-style: none;
  margin: 10px 0;
`;

export const NavigationBarFlyout = styled.div<{ isOpen: boolean }>`
  padding-top: 10px;
  padding-bottom: 20px;
  padding-left: 5px;
  overflow: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2100;
  width: 80%;
  height: 100vh;
  transform: translate3d(-100%, 0, 0);
  transition: transform 0.3s ease-out;
  background-color: ${props => props.theme.brandDefault};
  color: ${transparentize(0.2, '#fff')};

  ${props =>
    props.isOpen &&
    css`
      transform: none;
    `};
`;

export const CloseNavigationBar = styled.button`
  ${BareButtonStyle}
  z-index: 2101;
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  font-weight: 600;
  padding: 5px;
  border-radius: 25px;
  color: ${p => p.theme.grayDarker};
  background: white;
  width: 40px;
`;

export const NavigationBarFlyoutBackground = styled.div`
  position: absolute;
  top: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.4);
`;

export const MobileNavigationBarContainer = styled.div`
  box-shadow: 0 2px 4px ${props => transparentize(0.9, props.theme.grayBase)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 2000;
  height: 70px;
  background: white;
`;

export const MobileNavigationOpener = styled(Button)`
  z-index: 1;
`;

export const MobilePageTitleContainer = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 0;
  left: 0;
  right: 0;
  flex: 1;
  padding: 0 60px;
`;

export const MobileNavigationSecondaryContent = styled.div`
  position: relative;
  z-index: 1;
`;

export const MobileNavigationBarHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  height: 70px;
  text-align: center;
`;

export const MainNavigationBar = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${props => props.theme.brandDefault};
  color: ${transparentize(0.2, '#fff')};
`;

export const StickyNav = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 6001;
`;

export const NavigationBarContainer = styled.div`
  position: relative;
  z-index: 2000;
  box-shadow: 0 2px 4px ${props => transparentize(0.9, props.theme.grayBase)};
`;

export const NotificationsMenuItem = styled(Link)`
  display: flex;
  flex-direction: row;
  padding: 4px 0px;
  text-transform: none;
  background-color: #fff;
  color: ${props => props.theme.brandDefault};

  &:hover {
    background-color: ${props => props.theme.brandPrimary};
    color: #fff;
  }
`;
